// LIST
export const FETCH_SHEET = "app/SHEET/FETCH_SHEET";
export const FETCH_SHEET_SUCCESS = "app/SHEET/FETCH_SHEET_SUCCESS";
export const FETCH_SHEET_FAILURE = "app/SHEET/FETCH_SHEET_FAILURE";

export const SET_TIMESHEET_WEEK = "app/SHEET/SET_TIMESHEET_WEEK";
export const SET_ALLTIMESHEET_WEEK = "app/SHEET/SET_ALLTIMESHEET_WEEK";
export const SET_CURRENT_EMP = "app/SHEET/SET_CURRENT_EMP";
export const SET_TIMESHEET = "app/SHEET/SET_TIMESHEET";
export const SET_TIMESHEET_RANGE = "app/SHEET/SET_TIMESHEET_RANGE";

export const SET_CLOCK = "app/SHEET/SET_CLOCK";
export const SET_CLOCK_SUCCESS = "app/SHEET/SET_CLOCK_SUCCESS";
export const SET_CLOCK_FAILURE = "app/SHEET/SET_CLOCK_FAILURE";

export const UPDATE_CLOCK = "app/SHEET/UPDATE_CLOCK";
export const UPDATE_CLOCK_SUCCESS = "app/SHEET/UPDATE_CLOCK_SUCCESS";
export const UPDATE_CLOCK_FAILURE = "app/SHEET/UPDATE_CLOCK_FAILURE";

export const SET_APPROVAL = "app/SHEET/SET_APPROVAL";
export const SET_APPROVAL_SUCCESS = "app/SHEET/SET_APPROVAL_SUCCESS";
export const SET_APPROVAL_FAILURE = "app/SHEET/SET_APPROVAL_FAILURE";

export const TOGGLE_TIME_MODAL = "app/SHEET/TOGGLE_TIME_MODAL";
export const TOGGLE_VIEW = "app/SHEET/TOGGLE_VIEW";
export const TOGGLE_LIST_VIEW = "app/SHEET/TOGGLE_LIST_VIEW";
export const SET_REPORT_WEEK = "app/SHEET/SET_REPORT_WEEK";

export const EXPORT_TIMESHEET = "app/SHEET/EXPORT_TIMESHEET";
export const EXPORT_TIMESHEET_SUCCESS = "app/SHEET/EXPORT_TIMESHEET_SUCCESS";
export const EXPORT_TIMESHEET_FAILURE = "app/SHEET/EXPORT_TIMESHEET_FAILURE";

export const FETCH_ALL_SHEET = "app/SHEET/FETCH_ALL_SHEET";
export const FETCH_ALL_SHEET_SUCCESS = "app/SHEET/FETCH_ALL_SHEET_SUCCESS";
export const FETCH_ALL_SHEET_FAILURE = "app/SHEET/FETCH_ALL_SHEET_FAILURE";

export const FETCH_ALL_SHIFT = "app/SHEET/FETCH_ALL_SHIFT";
export const FETCH_ALL_SHIFT_SUCCESS = "app/SHEET/FETCH_ALL_SHIFT_SUCCESS";
export const FETCH_ALL_SHIFT_FAILURE = "app/SHEET/FETCH_ALL_SHIFT_FAILURE";

export const GET_ALLOCATION_REPORT = "app/SHEET/GET_ALLOCATION_REPORT";
export const GET_ALLOCATION_REPORT_SUCCESS =
  "app/SHEET/GET_ALLOCATION_REPORT_SUCCESS";
export const GET_ALLOCATION_REPORT_FAILURE =
  "app/SHEET/GET_ALLOCATION_REPORT_FAILURE";

export const LOCK_TIMESHEET = "app/SHEET/LOCK_TIMESHEET";
export const LOCK_TIMESHEET_SUCCESS = "app/SHEET/LOCK_TIMESHEET_SUCCESS";
export const LOCK_TIMESHEET_FAILURE = "app/SHEET/LOCK_TIMESHEET_FAILURE";

export const TOGGLE_LOCK = "app/SHEET/TOGGLE_LOCK";
export const TOGGLE_MAP_MODAL = "app/SHEET/TOGGLE_MAP_MODAL";
export const TOGGLE_HISTORY = "app/SHEET/TOGGLE_HISTORY";

export const GET_SHEET_HISTORY = "app/GET_SHEET_HISTORY";
export const GET_SHEET_HISTORY_SUCCESS = "app/GET_SHEET_HISTORY_SUCCESS";
export const GET_SHEET_HISTORY_FAILURE = "app/GET_SHEET_HISTORY_FAILURE";

export const UPDATE_ACCRUAL = "app/UPDATE_ACCRUAL";
export const UPDATE_ACCRUAL_SUCCESS = "app/UPDATE_ACCRUAL_SUCCESS";
export const UPDATE_ACCRUAL_FAILURE = "app/UPDATE_ACCRUAL_FAILURE";

export const SET_ACCRUAL = "app/SET_ACCRUAL";
export const SET_DEF_ACCRUAL = "app/SET_DEF_ACCRUAL";
export const SET_PAID = "app/SET_PAID";
export const SET_DEF_PAID = "app/SET_DEF_PAID";

export const SET_WEEK_STATS = "app/SET_WEEK_STATS";

export const GET_RANGE = "app/GET_RANGE";
export const GET_RANGE_SUCCESS = "app/GET_RANGE_SUCCESS";
export const GET_RANGE_FAILURE = "app/GET_RANGE_FAILURE";

export const UPDATE_PAID_HOURS = "app/UPDATE_PAID_HOURS";
export const UPDATE_PAID_HOURS_SUCCESS = "app/UPDATE_PAID_HOURS_SUCCESS";
export const UPDATE_PAID_HOURS_FAILURE = "app/UPDATE_PAID_HOURS_FAILURE";

export const FETCH_EMPS = "app/FETCH_EMPS";
export const FETCH_EMPS_SUCCESS = "app/FETCH_EMPS_SUCCESS";
export const FETCH_EMPS_FAILURE = "app/FETCH_EMPS_FAILURE";
export const UPDATE_SHEET_EMPS = "app/UPDATE_SHEET_EMPS";

export const FETCH_STATS = "app/FETCH_STATS";
export const FETCH_STATS_SUCCESS = "app/FETCH_STATS_SUCCESS";
export const FETCH_STATS_FAILURE = "app/FETCH_STATS_FAILURE";

export const GET_PAYROLL = "app/GET_PAYROLL";
export const GET_PAYROLL_SUCCESS = "app/GET_PAYROLL_SUCCESS";
export const GET_PAYROLL_FAILURE = "app/GET_PAYROLL_FAILURE";
export const UPDATE_PAYROLL_RANGE = "app/UPDATE_PAYROLL_RANGE";

export const LOCK_PAYROLL = "app/SHEET/LOCK_PAYROLL";
export const LOCK_PAYROLL_SUCCESS = "app/SHEET/LOCK_PAYROLL_SUCCESS";
export const LOCK_PAYROLL_FAILURE = "app/SHEET/LOCK_PAYROLL_FAILURE";

export const TOGGLE_LOCK_PAYROLL = "app/SHEET/TOGGLE_LOCK_PAYROLL";

export const TOGGLE_SHIFT = "app/SHEET/TOGGLE_SHIFT";

export const TOGGLE_GALLERY = "app/SHEET/TOGGLE_GALLERY";

export const EXPORT_PAYROLL = "app/SHEET/EXPORT_PAYROLL";
export const EXPORT_PAYROLL_SUCCESS = "app/SHEET/EXPORT_PAYROLL_SUCCESS";
export const EXPORT_PAYROLL_FAILURE = "app/SHEET/EXPORT_PAYROLL_FAILURE";

export const FETCH_BREAKS = "app/SHEET/FETCH_BREAKS";
export const FETCH_BREAKS_SUCCESS = "app/SHEET/FETCH_BREAKS_SUCCESS";
export const FETCH_BREAKS_FAILURE = "app/SHEET/FETCH_BREAKS_FAILURE";

export const SET_CURRENT_TIMESHEET = "app/SHEET/SET_CURRENT_TIMESHEET";

export const EXPORT_ALLOCATION = "app/SHEET/EXPORT_ALLOCATION";
export const EXPORT_ALLOCATION_SUCCESS = "app/SHEET/EXPORT_ALLOCATION_SUCCESS";
export const EXPORT_ALLOCATION_FAILURE = "app/SHEET/EXPORT_ALLOCATION_FAILURE";
